"use client"

import { motion } from "framer-motion"
import { containerVariants, itemVariants } from "./motion"
import StatCard from "./StatCard"
import LeadTypes from "./LeadTypes"
import ActiveCases from "./ActiveCases"
import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchDashboardSummary } from "../../../redux/features/agentDashboardSlice"

export default function MainDashboard() {
  const dispatch = useDispatch()
  const initialFetchDone = useRef(false)
  const user = localStorage.getItem("user")
  const userData = user ? JSON.parse(user) : null
  const { dashboardData, isLoading, error } = useSelector((state) => state.dashboardSummary)

  // Get the selected countries from the global state (managed by navbar)
  const globalCountries = useSelector((state) => state.globalCountries.globalCountries)

  useEffect(() => {
    // Fetch dashboard data when global countries change
    dispatch(fetchDashboardSummary(globalCountries))
    initialFetchDone.current = true
  }, [globalCountries, dispatch])

  return (
    <div className="md:p-4">
      <motion.div initial="hidden" animate="visible" variants={containerVariants}>
        <div className="flex flex-col md:flex-row justify-between mb-6">
          <motion.h1 variants={itemVariants} className="text-lg md:text-2xl font-normal mb-4 flex flex-row">
            <span>Hi {userData?.firstName || ""}!&nbsp;</span>
            <span className="hidden md:block">Let's get started for the day</span>
          </motion.h1>
          {/* Country dropdown removed - now using the one from navbar */}
        </div>
 
        {isLoading ? (
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="w-8 h-8 border-4 border-blue-900 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : error ? (
          <div className="text-red-500 text-center py-4">Error loading dashboard data: {error}</div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-6">
            <StatCard stats={dashboardData} />
            <LeadTypes leads={dashboardData?.TypesOfLeads} />
            <ActiveCases cases={dashboardData?.ActiveLeadsList} />
          </div>
        )}
      </motion.div>
    </div>
  )
}
